export default "__VITE_ASSET__KLzPzGmW__"